/**
 * One CSV cell. Values in the portal's CSV exports come from uploaded files
 * (prior-software exports, account names), so a leading `= + - @`, tab or CR is
 * neutralised with a `'` before quoting: a downloaded file must never open as a
 * live spreadsheet formula. Shared by every portal CSV export so the guard
 * cannot drift between copies again (final review of #1148).
 */
export function csvField(value: string): string {
  const safe = /^[=+\-@\t\r]/.test(value) ? `'${value}` : value;
  if (/[",\n]/.test(safe)) return `"${safe.replaceAll("\"", "\"\"")}"`;
  return safe;
}
